import { CSVTableRowProps } from 'types';
import { Select } from './styles';

const NanColumnRow = ({ rowIndex, columnLabels, isEditMode, values, useFormReturn }: CSVTableRowProps) => {
  const { register, watch } = useFormReturn;
  const nan = watch('nan');

  if (isEditMode) {
    const value = {
      none: '미사용',
      drop: 'Drop',
      fill: 'Fill',
    } as Record<string, string>;
    return (
      <tr>
        <th>결측치</th>
        <td>
          <Select {...register('nan')}>
            <option value="none">미사용</option>
            <option value="drop">Drop</option>
            <option value="fill">Fill</option>
          </Select>
        </td>
        {columnLabels.map((label, i) => (
          <td key={`col/${label}/row/${rowIndex}/edit`}>{values?.[i] !== undefined && <span>{value[nan]}</span>}</td>
        ))}
      </tr>
    );
  }

  return (
    <tr>
      <th>{rowIndex}</th>
      {columnLabels.map((label) => (
        <td key={`col/${label}/row/${rowIndex}`}></td>
      ))}
    </tr>
  );
};

export default NanColumnRow;
